import Vue from 'vue';
import Component from 'vue-class-component';

import Datepicker from 'vuejs-datepicker';
import dayjs from 'dayjs';

import outSideClick from 'common/directives/outSideClick';

Vue.directive('outSideClick', outSideClick);

@Component({
  components: {
    Datepicker,
  },
  props: {
    disabledDates: {
      type: Object,
      default: () => {},
      description: 'https://www.npmjs.com/package/vuejs-datepicker#disabled-dates',
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    clickOutside: outSideClick.directive,
  },
})
export default class DatePickerComponent extends Vue {
  selectedDate = null;

  onClickOutside() {
    this.$emit('clickedOutside');
  }

  /*
   * Formate default date value, this expects that 'value' prop.
   * the wey we do it its because safari dosent support array as constructor
   * have this format: DD/MM/YYYY
   */
  get formatedValue() {
    if (this.value) {
      const dayArr = this.value.split('/').reverse();
      return new Date(dayArr[0], dayArr[1] - 1, dayArr[2]);
    }
    return new Date();
  }

  dateChanged(e) {
    this.selectedDate = dayjs(e).format('DD/MM/YYYY');
    this.$emit('select', e);
  }

  get dateFormated() {
    return dayjs(this.value, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }
}
